import { useKeyboardShortcutEngine } from '../../../hooks/useKeyboardShortcutEngine';

/** Mounts the global shortcut listener (must live inside KeyboardShortcutsProvider). */
export default function KeyboardShortcutEngineHost() {
  useKeyboardShortcutEngine();
  return null;
}
